import React from "react";
import { Tabs, Tab, Nav } from "react-bootstrap";
import "./EditMentorProfile.scss";
import PersonalInformation from "./PersonalInformation";
import EducationalInformation from "./EducationalInformation";
import ProfessionalInformation from "./ProfessionalInformation";
import PortfolioInformation from "./PortfolioInformation";
import SkillsInformation from "./SkillsInformation";
import MainLayout from "../../Common/MainLayout";
import useEditMentorProfile from "./useEditMentorProfile";

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  const {
    activeTab
  } = useEditMentorProfile(props);
  return (
    <MainLayout pageName="Edit Profile">
      <div className="edit-candidate-profile-wrapper footer-gap">
        <div className="container">
          {activeTab && (
            <Tab.Container className="mb-3 pb-4" defaultActiveKey={activeTab}>
              <Nav className="nav-tabs">
                <Nav.Item>
                  <Nav.Link eventKey="SkillsExperience">
                    <span className="font-weight-semi">Skills & Experience</span>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="PersonalInformation">
                    <span className="font-weight-semi">Personal Information </span>
                  </Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link eventKey="Education">
                    <span className="font-weight-semi">Education </span>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="ProfessionalInformation">
                    <span className="font-weight-semi">Work Experience  </span>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="MyPortfolio">
                    <span className="font-weight-semi">My portfolio </span>
                  </Nav.Link>
                </Nav.Item>
              </Nav>
              <Tab.Content>
                <Tab.Pane eventKey="SkillsExperience">
                  <SkillsInformation />
                </Tab.Pane>
                <Tab.Pane eventKey="PersonalInformation">
                  <PersonalInformation />
                </Tab.Pane>
                <Tab.Pane eventKey="Education">
                  <EducationalInformation />
                </Tab.Pane>
                <Tab.Pane eventKey="ProfessionalInformation">
                  <ProfessionalInformation />
                </Tab.Pane>
                <Tab.Pane eventKey="MyPortfolio">
                  <PortfolioInformation />
                </Tab.Pane>
              </Tab.Content>

            </Tab.Container>
          )}
        </div>
      </div>
    </MainLayout>
  );
};
